"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Slider_1 = __importDefault(require("../Slider"));
var WorkDurationPicker = function (_a) {
    var value = _a.value, min = _a.min, max = _a.max, step = _a.step, disabled = _a.disabled, onValueChange = _a.onValueChange;
    return (react_1.default.createElement("div", { className: "emankit__work_duration_picker" },
        react_1.default.createElement(Slider_1.default, { min: min, max: max, step: step, onChange: onValueChange, value: value, disabled: disabled }),
        react_1.default.createElement("span", { className: "selected_hours" },
            value,
            "h")));
};
exports.default = WorkDurationPicker;
//# sourceMappingURL=index.js.map